module.exports = __webpack_public_path__ + "img/Animation-1698908464778.07bf964.gif";